import { EditorView } from 'prosemirror-view'
import { DOMParser as ProseMirrorDOMParser, DOMSerializer } from 'prosemirror-model'
import { marked } from 'marked'
import { turndownService } from './turndown'

/** Convert markdown to ProseMirror content and replace the entire document. */
export function applyMarkdownToEditor(view: EditorView, markdown: string) {
  const html = marked(markdown, { gfm: true }) as string
  const container = document.createElement('div')
  container.innerHTML = html
  const parsed = ProseMirrorDOMParser.fromSchema(view.state.schema).parse(container)
  view.dispatch(view.state.tr.replaceWith(0, view.state.doc.content.size, parsed.content))
}

/** Convert markdown to ProseMirror content and insert it at a specific position. Returns the inserted range. */
export function insertMarkdownAtPosition(view: EditorView, markdown: string, position: number): { from: number; to: number } {
  const sizeBefore = view.state.doc.content.size
  const html = marked(markdown, { gfm: true }) as string
  const container = document.createElement('div')
  container.innerHTML = html
  const parsed = ProseMirrorDOMParser.fromSchema(view.state.schema).parse(container)
  view.dispatch(view.state.tr.insert(position, parsed.content))
  const insertedLength = view.state.doc.content.size - sizeBefore
  return { from: position, to: position + insertedLength }
}

/** Serialize the current ProseMirror document to markdown. */
export function serializeEditorToMarkdown(view: EditorView): string {
  const serializer = DOMSerializer.fromSchema(view.state.schema)
  const div = document.createElement('div')
  div.appendChild(serializer.serializeFragment(view.state.doc.content))
  return turndownService.turndown(div.innerHTML)
}
